export const stepLabelForRoute = route => {
  if (!route) return null;
  if (route.includes('/intro/')) return 'Intro';
  if (route.includes('/plans/')) return 'Pick your plan';
  if (
    route.includes('/preference/dietary/') ||
    route.includes('/preference/avoid/') ||
    route.includes('/promo/')
  ) {
    return 'Preferences';
  }
  if (
    route.includes('/box-people/') ||
    route.includes('/box-meals/') ||
    route.includes('/box-days/') ||
    route.includes('/box/')
  ) {
    return 'Box Size';
  }
  if (route.includes('/billing/')) return 'Checkout';
  if (route.includes('/thankyou/')) return 'Pick Meals';

  return null;
};

export const getFunnelProgressSteps = funnel => {
  if (!funnel?.length) return [];

  return funnel.reduce((steps, step) => {
    const name = stepLabelForRoute(step.route);
    const locationPercentage = parseInt(step.locationPercentage);

    if (!name || Number.isNaN(locationPercentage)) return steps;
    if (steps.some(existingStep => existingStep.name === name)) return steps;

    return [...steps, { name, locationPercentage }];
  }, []);
};
